<script>
	import Light from "./elements/Light.svelte";
	import { isPortraitScreen, pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _lightLeft;
	let _lightRight;
	let portrait;

	let animationLeft = (value) => {
		animateElement(value, _lightLeft, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset * 0.2;
			_lightLeft.style.transform = `translateY(-${Math.min(100, scrolledStartSectionPercentage) / 3}px)`;
		});
	};

	let animationRight = (value) => {
		animateElement(value, _lightRight, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset * 0.2;
			_lightRight.style.transform = `translateY(-${Math.min(100, scrolledStartSectionPercentage) / 4}px)`;
		});
	};

	let prepareLeft = () => {
		if (!_lightLeft) {
			requestAnimationFrame(prepareLeft);
			return;
		}

		pageOffset.subscribe(animationLeft);
	};
	let prepareRight = () => {
		if (!_lightRight) {
			requestAnimationFrame(prepareRight);
			return;
		}

		pageOffset.subscribe(animationRight);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareLeft();
	prepareRight();
</script>

<style>
	div {
		position: absolute;
		height: 15em;
		bottom: 0;
		width: auto;
	}

	.portrait div {
		height: 10em;
	}

	#left-light {
		left: 0;
		bottom: 8em;
	}

	.portrait #left-light {
		bottom: -4em;
		left: -1em;
	}

	#right-light {
		display: block;
		left: 7em;
		bottom: 4em;
	}

	.portrait #right-light {
		display: none;
	}
</style>

<div class:portrait>
	<div id="left-light" bind:this={_lightLeft}>
		<Light direction="ltr" id="light_1"/>
	</div>

	<div id="right-light" bind:this={_lightRight}>
		<Light direction="rtl" id="light_2"/>
	</div>
</div>
